<template>
  <div class="studentRow fRow jStart aCenter fullWidth wrap">
    <!-- <div class="savatar"></div> -->
    <div class="mainInfo fRow jStart aCenter growFull">
      <div class="av" v-bind:style="{
        backgroundImage: `url(https://api.rimik.ir/${data.avatar})`,
      }"></div>
      <div class="fCol jCenter aStart growFull">
        <div class="sName">{{data.fullName}}</div>
        <div class="sGrade">{{data.summary}}</div>
      </div>
      <div class="plan fCol jCenter aCenter">
        <label class="mini">تعداد دوره‌ها</label>
        <span>{{data.courses}} دوره</span>
      </div>
      <div class="plan fCol jCenter aCenter">
        <label class="mini">امتیـــاز</label>
        <span>{{data.courses}}</span>
      </div>
      <div class="phone fCol jCenter aCenter">
        <label class="mini">شماره تماس</label>
        <span>{{data.mobile.replace('98', '0')}}</span>
      </div>
    </div>
    <div class="status fCol jCenter aCenter">
      <label class="mini">وضعیت</label>
      <switch-button
        activeLabel="فعال"
        deactiveLabel="غیرفعال"
        :val="status"
        @click.native="invertState"/>
    </div>
    <div class="sActions fRow jCenter aCenter">
      <div class="b fRow jStart aCenter" @click="EditTeacher">
        <label>مشاهده و ویرایش</label>
      </div>
      <i class="material-icons-round fRow jCenter aCenter"
        @click="deleteMode = true">delete</i>
    </div>
    <div class="deleteBox fRow jStart aCenter" v-if="deleteMode">
      <i class="material-icons-round del">delete</i>
      <div class="fCol deleteQuestion jCenter aStart">
        <div class="q">آیا از حذف {{data.fullName}} مطمئنید؟</div>
        <div class="d">این عملیات امکان بازگشت ندارد</div>
      </div>
      <div class="dbtn fRow jCenter aCenter" @click="deleteTeacher">
        <i class="material-icons-round">delete_sweep</i>
        <label>بله مطمئنم، حذف شود</label>
      </div>
      <div class="mbtn fRow jCenter aCenter mini" @click="deleteMode = false">
        <i class="material-icons-round">close</i>
        <label>انصراف</label>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchButton from '@/components/SwitchButton.vue';
import moment from 'moment-jalaali';
import makeToast from '@/mixins/makeToast';
import errorHandler from '@/mixins/mixin';
// import moment from 'moment-jalaali';
import axios from 'axios';
import 'vue-cool-select/dist/themes/material-design-dark.scss';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'idx'],
  components: {
    SwitchButton,
  },
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      addPay: false,
      addAdvisor: false,
      status: false,
      editMode: false,
      expanded: false,
      assignmentDates: {
        from: '',
        to: '',
        duration: '',
      },
      paymentModal: false,
      paymentLoad: false,
      advisorModal: false,
      deleteModal: false,
      parentModal: false,
      modal: false,
      advisors: [
        {
          consultantId: '1',
          consultantFullName: 'مشاور یک',
        },
        {
          consultantId: '2',
          consultantFullName: 'مشاور 2',
        },
        {
          consultantId: '3',
          consultantFullName: 'مشاور 3',
        },
        {
          consultantId: '4',
          consultantFullName: 'مشاور 4',
        },
        {
          consultantId: '5',
          consultantFullName: 'مشاور 5',
        },
      ],
      sAdvisor: '',
      sAdvisorId: '',
      sAdvisorIdErr: true,
      payments: [],
      // form
      sFirstName: '',
      sFirstNameErr: true,
      sLastName: '',
      sLastNameErr: true,
      sContractStart: '',
      sContractEnd: '',
      sPlan: '',
      sFatherName: '',
      sFatherNameErr: true,
      sNationalCode: '',
      sNationalCodeErr: true,
      sUserName: '',
      sField: 0,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      conventions: [],
      conventionsData: [],
      convention: '',
      conventionErr: true,
      // simple example of items
      fields: [
        {
          id: -1,
          title: 'رشته انتخاب نشده',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'هنر',
        },
        {
          id: 6,
          title: 'زبان',
        },
      ],
      field: '',
      fieldErr: true,
      // pay datas
      payMethods: [
        {
          id: 1,
          title: 'پرداخت نقدی',
        },
        {
          id: 2,
          title: 'پرداخت کارت به کارت',
        },
        {
          id: 3,
          title: 'پرداخت چکی',
        },
        {
          id: 4,
          title: 'پرداخت نشده',
        },
      ],
      payMethod: '',
      payMethodErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      payDesc: '',
      payDescErr: true,
      deleteMode: false,
    };
  },
  watch: {
    payDate() {
      if (this.payDate !== '') {
        // console.log('date', this.payDate);
        this.payDateShow = moment(this.payDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.payDateErr = false;
      } else {
        this.payDateErr = true;
        this.payDateShow = '';
      }
    },
    startDate() {
      if (this.startDate !== '') {
        // this.sContractStart = startDate;
        // console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // this.sContractEnd = endDate;
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.etErr = true;
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    payDesc() {
      if (this.payDesc.length === 0) {
        this.payDescErr = true;
      } else if (this.payDesc.length > 128) {
        this.payDesc = this.payDesc.substr(0, 128);
        this.payDescErr = false;
      } else {
        this.payDescErr = false;
      }
    },
    sContractStart() {
      this.startDate = this.sContractStart;
    },
    sContractEnd() {
      this.endDate = this.sContractEnd;
    },
    // validations
    sAdvisorId() {
      if (this.sAdvisorId !== '') {
        this.sAdvisorIdErr = false;
      } else {
        this.sAdvisorIdErr = true;
      }
    },
    sFirstName() {
      if (this.sFirstName !== '' && this.sFirstName !== null) {
        if (this.sFirstName.length > 24) {
          this.sFirstName = this.sFirstName.substr(0, 24);
        }
        this.sFirstNameErr = false;
      } else {
        this.sFirstNameErr = true;
      }
    },
    sLastName() {
      if (this.sLastName !== '' && this.sLastName !== null) {
        if (this.sLastName.length > 24) {
          this.sLastName = this.sLastName.substr(0, 24);
        }
        this.sLastNameErr = false;
      } else {
        this.sLastNameErr = true;
      }
    },
    sFatherName() {
      if (this.sFatherName !== '' && this.sFatherName !== null) {
        if (this.sFatherName.length > 24) {
          this.sFatherName = this.sFatherName.substr(0, 24);
        }
        this.sFatherNameErr = false;
      } else {
        this.sFatherNameErr = true;
      }
    },
    sNationalCode() {
      if (this.sNationalCode >= 0 && this.sNationalCode !== null) {
        if (this.sNationalCode.length > 10) {
          this.sNationalCode = this.sNationalCode.substr(0, 10);
          this.sNationalCodeErr = false;
        } else if (this.sNationalCode < 10) {
          this.sNationalCodeErr = true;
        } else {
          this.sNationalCodeErr = false;
        }
      } else {
        this.sNationalCodeErr = true;
      }
    },
    field() {
      if (this.field.length !== 0) {
        this.fieldErr = false;
        if (this.field.id === -1) {
          this.fieldErr = true;
        }
      } else {
        this.fieldErr = false;
      }
    },
    convention() {
      if (this.convention.length > 0) {
        this.sAdvisorIdErr = false;
      } else {
        this.sAdvisorIdErr = true;
      }
    },
  },
  methods: {
    dateMoment(d) {
      return moment(d, 'YYYY-MM-DDTHH:mm:00')
        .locale('FA')
        .format('jDD jMMMM jYYYY');
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    getConventions() {
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Conventions/consultant`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          this.fieldErr = false;
          break;
        }
        case 'plan': {
          this.planErr = false;
          break;
        }
        case 'convention': {
          this.conventionErr = false;
          this.consultantId = e.id;
          this.sAdvisorId = e.id;
          break;
        }
        case 'payMethod': {
          this.payMethodErr = false;
          if (this.payMethod.id === 4) {
            this.notPayed = true;
            this.payDate = '';
          } else {
            this.notPayed = false;
          }
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    changeState() {
      this.status = !this.status;
    },
    openModal(modal) {
      this.modal = true;
      switch (modal) {
        case 'payment': {
          this.paymentModal = true;
          this.getPayment();
          break;
        }
        case 'advisor': {
          this.advisorModal = true;
          this.getConventions();
          break;
        }
        case 'delete': {
          this.deleteModal = true;
          break;
        }
        case 'parent': {
          this.parentModal = true;
          break;
        }
        default:
          break;
      }
    },
    closeModal() {
      this.paymentModal = false;
      this.advisorModal = false;
      this.deleteModal = false;
      this.parentModal = false;
      this.modal = false;
    },
    invertState() {
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Teachers/${this.data.teacherId}?status=${!this.status}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.status = !this.status;
          if (this.gradeStatus) {
            this.makeToast('success', 'مدرس مورد نظر فعال شد', 2000);
          } else {
            this.makeToast('success', 'مدرس مورد نظر غیرفعال شد', 2000);
          }
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    EditTeacher() {
      this.$emit('edit', this.data);
    },
    getPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments/${this.data.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.payments = response.data.data;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    deleteTeacher() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.data.teacherId}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.$emit('refresh');
          this.makeToast('success', 'مدرس موفقیت حذف شد', 3000);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    newPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments`;
      axios({
        method: 'post',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          userId: this.data.userId,
          paymentType: this.payMethod.title,
          paymentAmount: this.payAmount.replace(/,/g, ''),
          paymentDate: this.payDate,
          paymentDescription: this.payDesc,
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.getPayment();
          this.clearPayForm();
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    clearPayForm() {
      this.payDate = '';
      this.payAmount = '';
      this.payMethod = '';
      this.payDesc = '';
    },
    cancelEdit() {
      this.init();
      this.editMode = false;
    },
    init() {
      this.status = this.data.status;
    },
    // format date
    formatDate(d) {
      return moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('jDD jMMMM jYYYY');
    },
  },
  computed: {
    isPayReady() {
      let a = false;
      if (this.notPayed) {
        a = !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      } else {
        a = !this.payDateErr
          && !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      }
      return a;
    },
    contractDuration() {
      if (this.startDate !== '' && this.endDate !== '') {
        return Math.round(moment(this.endDate).diff(this.startDate, 'months', true));
      }
      return '~';
    },
    isEditReady() {
      const a = !this.sAdvisorIdErr
        && !this.sFirstNameErr
        && !this.sLastNameErr
        && !this.stErr
        && !this.etErr
        && !this.sNationalCodeErr
        && !this.sFatherNameErr
        && !this.fieldErr;
      return a;
    },
  },
  mounted() {
    this.init();
    // console.log('teacher row');
  },
};
</script>

<style lang="scss" scoped>
.studentRow {
  padding: 8px;
  border-radius: 16px 48px 48px 16px;
  $av: 88px;
  position: relative;
  overflow: hidden;
  background-color: rgba($color: #000000, $alpha: 0.0);
  $dash: dashed 1px rgba(0,0,0,0.15);
  label.mini {
    font-size: 10px;
    margin-bottom: 4px;
  }
  .mainInfo {
    .av {
      width: $av;
      height: $av;
      margin-left: 16px;
      border-radius: 50%;
      background-color: rgba($color: #000000, $alpha: 0.15);
      box-shadow: 0 16px 16px -12px rgba($color: #000000, $alpha: 0.15);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .sName {
      font-size: 18px;
      font-weight: bold;
    }
    .sGrade {
      font-size: 12px;
    }
    .plan {
      width: 88px;
      border: dashed 1px rgba($color: #000000, $alpha: 0.15);
      border-top: none;
      border-bottom: none;
      span {
        padding: 2px 6px;
        border-radius: 16px;
        background-color: rgba($color: rgb(70, 150, 70), $alpha: 0.15);
        font-weight: bold;
        font-size: 12px;
      }
    }
    .phone {
      width: 112px;
      border-left: dashed 1px rgba($color: #000000, $alpha: 0.15);
      span {
        padding: 2px 6px;
        border-radius: 16px;
        font-size: 14px;
      }
    }
    .date {
      width: 126px;
      span {
        padding: 2px 6px;
        border-radius: 16px;
        font-size: 12px;
      }
      label {
        font-size: 12px;
        line-height: 1;
        opacity: 0.2;
        margin-bottom: -2px;
      }
    }
  }
  .status {
    width: 96px;
  }
  .sActions {
    margin-right: 16px;
    i {
      margin: 4px;
      border-radius: 50%;
      padding: 8px;
      font-size: 16px;
      background-color: rgba($color: #000000, $alpha: 0.15);
    }
    i.active {
      background-color: rgba($color: #67ee45, $alpha: 1);
    }
    @keyframes empty {
      0% {
        box-shadow: 0 0 0 4px rgba($color: red, $alpha: 0.35);
      }
      100% {
        box-shadow: 0 0 0 4px rgba($color: red, $alpha: 0.0);
      }
    }
    i.empty {
      animation: empty cubic-bezier(1, 0, 0, 1) 2s infinite alternate;
      background-color: rgba($color: red, $alpha: 1.0);
      color: white;
    }
  }
  .deleteBox {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: red;
    z-index: 200;
    padding: 0 16px;
    i.del {
      font-size: 32px;
      color: white;
      text-shadow: 0 4px 0px rgba($color: #000000, $alpha: 0.25);
      margin-left: 16px;
    }
    .deleteQuestion {
      margin-left: 16px;
      .q {
        font-size: 16px;
        font-weight: bold;
        color: white;
      }
      .d {
        font-size: 12px;
        color: white;
      }
    }
    .dbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: white;
      color: #000000;
      margin-left: 8px;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 16px;
      }
      label {
        font-size: 14px;
      }
    }
    .mbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: rgba(0, 0, 0, 0.082);
      color: #ffffff;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 12px;
        color: white;
      }
      label {
        font-size: 12px;
        font-weight: bold;
        color: white;
      }
    }
  }
}
.studentRow:nth-child(odd) {
  background-color: rgba($color: #000000, $alpha: 0.05) !important;
}
</style>
